module.exports = __webpack_public_path__ + "static/media/4 กรณีพิมพ์ใบเสร็จไม่ได้_0.02621508.jpg";